import { type ParseableError } from '@nx/errors';

import { type Suggestion } from '../../../modules/SearchBar/types';

export enum STATUS {
  IDLE = 'idle',
  FETCHING_DATA = 'fetching-data',
  FETCHING_SUGGESTIONS = 'fetching-suggestions',
  DEBOUNCING = 'debouncing',
  FAILED = 'failed',
  SUCCEEDED = 'succeeded',
}

export type SearchStatus =
  | {
      status: STATUS.IDLE | STATUS.FETCHING_DATA | STATUS.FETCHING_SUGGESTIONS | STATUS.DEBOUNCING;
    }
  | {
      status: STATUS.FAILED;
      error: ParseableError;
      nodesCount?: number;
    }
  | {
      status: STATUS.SUCCEEDED;
      nodesCount: number;
      relationshipsCount: number;
      isUpdateQuery?: boolean;
      recordLimitHit?: boolean;
    };

export interface SearchCoreState {
  filter: string;
  inputText: string;
  // suggestion path that is selected in dropdown
  selectedSuggestionPathIdx: number;
  // suggestions in search box
  lockedSuggestions: Suggestion[];
  labelsWithNodesUnderLimit: string[];
  initialFocus: boolean;
  isGenAIAssistantEnabled: boolean;
  searchStatus: SearchStatus;
  genAiLastAskedQuestion?: string | undefined;
  facetedResults?: {
    nodes?: any[]; // todo
    relationships?: any[]; // todo
  };
}
